import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  type: 'lookbook',
  aliases: ['lookbook'],
  path: 'Lookbook/LookbookTemplate.vue',
  slices: [{
    name: 'global_footer',
    path: 'Global/GlobalFooter.vue'
  }]
};